import { useTheme } from '@mui/material'
import { DataGrid, DataGridProps, GridValidRowModel } from '@mui/x-data-grid'
import { adjustColorForTheme } from 'styles/utils'

type IDataGridComponentProps<
  T extends GridValidRowModel = GridValidRowModel
> = DataGridProps<T>

const DataGridBase = <T extends GridValidRowModel = GridValidRowModel>(
  props: IDataGridComponentProps<T>
) => {
  const theme = useTheme()

  const baseSx = {
    '& .MuiDataGrid-row': {
      background: theme.palette.tabBorder.main,

      '&:hover': {
        background: adjustColorForTheme(
          theme.palette.mode,
          theme.palette.tabBorder.main,
          0.1
        )
      }
    }
  }

  const mergedSx = Array.isArray(props.sx)
    ? [baseSx, ...props.sx]
    : { ...baseSx, ...props.sx }

  return (
    <DataGrid
      {...props}
      sx={mergedSx}
    />
  )
}

export default DataGridBase
